import ViewController from '@af-modules/databinding/prototypes/ViewController';
import { Router } from '@af-modules/router';

const AppDrawer = {

    template: 'nav-drawer',

    _isOpen: false,

    navList: [{
        name: 'Home',
        path: '/home',
    }, {
        name: 'Blog',
        path: '/blog',
    }, {
        name: 'Imprint',
        path: '/imprint',
    }],

    get isOpen() {
        return this._isOpen;
    },

    set isOpen(value) {
        this._isOpen = value;
        this.scope.update();
    },

    get currentPage() {
        return this.navList.findIndex(item => item.path === ('/' + Router.getCurrentPath().slice(1).join('/'))) + 1;
    },

    link(path) {
        return `#!${path}`;
    },

    onItemSelected(event, scope) {
        setTimeout(() => {
            this.isOpen = false;
            scope.update();
        }, 200);
    },

    __proto__: ViewController,
};

export default AppDrawer;



//////////////////
// WEBPACK FOOTER
// ./modules/AppDrawer.js
// module id = 21
// module chunks = 0